import { render, staticRenderFns } from "./PanelMenu.vue?vue&type=template&id=9208e644&scoped=true"
import script from "./PanelMenu.vue?vue&type=script&lang=ts"
export * from "./PanelMenu.vue?vue&type=script&lang=ts"
import style0 from "./PanelMenu.vue?vue&type=style&index=0&id=9208e644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9208e644",
  null
  
)

export default component.exports